export function formatDateWithTimezone(iso) {
  if (!iso) return '—';
  const date = new Date(iso.endsWith('Z') ? iso : iso + 'Z');
  const offset = -date.getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offset) / 60);
  const offsetMinutes = Math.abs(offset) % 60;
  const timezoneFormatted = `UTC${offset >= 0 ? '+' : '-'}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;
  return `${date.toLocaleDateString()} ${date.toLocaleTimeString()} (${timezoneFormatted})`;
}
